export { default as ProductsAiSearchDetectFileAttachmentPreview } from './ProductsAiSearchDetectFileAttachmentPreview';
